import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}
const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  ...props
}, ref) => {
  return <input type={type} className={cn('flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus:outline-none focus:border-lime-1 focus-visible:outline-none focus-visible:border-lime-1 disabled:cursor-not-allowed disabled:opacity-50 transition-colors', className)} ref={ref} {...props} data-id="element-2838" />;
});
Input.displayName = 'Input';
export { Input };